import React from "react";
import { useSelector } from "react-redux";

import RightColumnMainComponent from "./right-column-main/right-column-main.component";
import styles from "./right-column.module.scss";
import Header from "./header/header.component";
import RightColumnFooterComponent from "./right-column-footer/right-column-footer.component";

import { ApplicationStore } from "~/app/application.store";

const RightColumnComponent: React.FC = () => {
  const selectChatId: string | null = useSelector((state: ApplicationStore) => state.chats.selectChatId);
  return (
    <div className={styles.rightColumn}>
      {selectChatId && (
        <>
          <Header />
          <RightColumnMainComponent />
          <RightColumnFooterComponent />
        </>
      )}
    </div>
  );
};

export default RightColumnComponent;
